<template>
  <div ref="root" class="modern-shell" :class="{ 'modern-shell--document': contentLayout === 'document' }">
    <main class="modern-shell__content"><slot /></main>
  </div>
</template>

<script>
import { interfacePreferencesController } from '@/shells/services/interfacePreferencesController';
import { MODERN_THEME_KEY, ModernThemeController } from '@/shells/services/modernThemeController';

// This is only the themed content host. App owns the one shared navigation
// instance, including account actions and the selected content experience.
export default {
  name: 'ModernShell',
  props: { contentLayout: { type: String, default: 'viewport' } },
  provide() { return { [MODERN_THEME_KEY]: this.themeController.state }; },
  data() { return { themeController: new ModernThemeController() }; },
  computed: {
    uid() { return this.$store.state.user_id || (this.$store.state.user || {}).uid || 0; },
    preferenceState() { return interfacePreferencesController.stateFor(this.uid); },
    themeMode() { return this.preferenceState.preferences.themeMode; },
    effectiveTheme() { return this.themeController.state.effectiveTheme; }
  },
  watch: {
    themeMode(mode) { this.themeController.setMode(mode); },
    effectiveTheme: { immediate: true, handler(theme) { this.$emit('effective-theme', theme); } }
  },
  mounted() {
    this.themeController.mount(this.$refs.root, this.themeMode);
    interfacePreferencesController.load(this.uid).catch(() => {});
  },
  beforeDestroy() { this.themeController.unmount(); }
};
</script>

<style lang="scss">
.modern-shell {
  --modern-layer-modal: 10040;
  --modern-layer-popover: 10050;
  --modern-layer-feedback: 10060;
  --modern-shell-header-height: 62px;
  --modern-bg: #f6f8fb;
  --modern-surface: #ffffff;
  --modern-text: #15202b;
  --modern-muted: #657181;
  --modern-border: #dfe5ec;
  --modern-accent: #008db5;
  --modern-accent-soft: #e6f7fb;
  min-height: calc(100vh - var(--modern-shell-header-height));
  min-height: calc(100dvh - var(--modern-shell-header-height));
  background: var(--modern-bg);
  color: var(--modern-text);
  color-scheme: light;
}
.modern-shell.modern-theme-dark {
  --modern-bg: #10131a;
  --modern-surface: #191e28;
  --modern-text: #f5f7fa;
  --modern-muted: #aab4c2;
  --modern-border: #303846;
  --modern-accent: #51c5e5;
  --modern-accent-soft: #173642;
  color-scheme: dark;
}
.modern-shell__content {
  min-width: 0;
  min-height: calc(100vh - var(--modern-shell-header-height));
  min-height: calc(100dvh - var(--modern-shell-header-height));
}
.modern-shell .charting-workspace {
  min-height: calc(100vh - var(--modern-shell-header-height));
  min-height: calc(100dvh - var(--modern-shell-header-height));
}
@media (min-width: 1100px) {
  .modern-shell:not(.modern-shell--document) {
    height: calc(100vh - var(--modern-shell-header-height));
    height: calc(100dvh - var(--modern-shell-header-height));
    min-height: 0;
    overflow: hidden;
  }
  .modern-shell:not(.modern-shell--document) > .modern-shell__content {
    height: calc(100vh - var(--modern-shell-header-height));
    height: calc(100dvh - var(--modern-shell-header-height));
    min-height: 0;
    overflow: hidden;
  }
  .modern-shell .charting-workspace {
    height: 100%;
    min-height: 0;
  }
}
</style>
